export const TEXT_VARIANTS = ['1000', '900', '800', '700', '600', '200', '100', '100-r', '50', '50-r'];
export const ADHOC_RICH_TEXT_OPTIONS = ['badge', 'stat', 'center', 'max-width-none'];
export const HEADER_ELEMENTS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export const TEXT_ELEMENTS = [...HEADER_ELEMENTS, 'p', 'span', 'div'];
